export default __webpack_public_path__ + "static/cross-lines-419c157069694fdf7f6661dcce60cf6b.png";